import '../style.css';

import React, { ReactNode } from 'react';
import einvoice from './einvoice.png';
import mail from './mail.png';

interface SendByProps {
    icon: string;
    title: ReactNode;
    text?: ReactNode;
}

function SendBy({ icon, title, text }: SendByProps) {
    return (
        <div className="send_by">
            <div className="send_by__icon__container">
                <img src={icon} alt={icon} className="send_by__icon__container__image" />
            </div>
            <div className="send_by__text">
                <h3 style={{ marginBottom: 0 }}>{title}</h3>
                {text}
            </div>
        </div>
    );
}

interface SendAsEInvoiceProps {
    title: ReactNode;
    text?: ReactNode;
}

export function SendAsEInvoice(props: SendAsEInvoiceProps) {
    return <SendBy icon={einvoice} {...props} />;
}

interface SendAsEmailProps {
    title: ReactNode;
    text?: ReactNode;
}

export function SendAsEmail(props: SendAsEmailProps) {
    return <SendBy icon={mail} {...props} />;
}
